/**
 * BETA 15.56 — Centralized dev-user list + helper.
 *
 * Per Dylan: "can you unlock every item for me. that is my username
 * [DevPeanut]." Was previously duplicated in 3 places (sessionTracker.ts,
 * DevPanel.tsx, GameCanvas.tsx) with INCONSISTENT contents (sessionTracker
 * had only 2 names; the other two had 5). Now there's one source of truth.
 *
 * Adding a new dev user → add to this list ONLY.
 */
export const DEV_USERS = [
  'DevPeanut',
  'KaySeaBass',
  'aBakedPotato',
  'Mr. Permission',
  'Peeb',
  'LogiCC', // BETA 21.05 — new dev tester (their account self-signs-up with username 'LogiCC')
] as const;

/**
 * BETA 21.06 — DEV ACCESS CODES (the easy-onboarding path).
 *
 * A tester you send a code to types it on the sign-in screen and is logged
 * straight in as a dev (everything unlocked + dev panel) — NO email, NO
 * password, NO email-confirmation, NO manual Supabase step. Their login is
 * remembered on that device so they only enter the code once ("locked in").
 *
 * TO ADD A TESTER: add ONE line here → 'THEIR-CODE': 'TheirName'.
 * That name is auto-granted dev access (you do NOT also need to touch
 * DEV_USERS). Codes are matched case-insensitively. Each tester should get
 * their own unique code so you can tell who's who / retire one later.
 */
export const DEV_ACCESS_CODES: Record<string, string> = {
  'LOGICC-PEANUT': 'LogiCC',
};

/** Returns the dev username for a valid code, or null. Case-insensitive. */
export function validateDevCode(code: string | null | undefined): string | null {
  if (!code) return null;
  const key = code.trim().toUpperCase();
  for (const [c, name] of Object.entries(DEV_ACCESS_CODES)) {
    if (c.toUpperCase() === key) return name;
  }
  return null;
}

export function isDevUser(username: string | null | undefined): boolean {
  if (!username) return false;
  return (DEV_USERS as readonly string[]).includes(username)
    || Object.values(DEV_ACCESS_CODES).includes(username); // code-granted dev testers
}
